/*=========================================================================================
  File Name: moduleEmail.js
  Description: Email Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleRequestState.js'
import mutations from './moduleRequestMutations.js'
import actions from './moduleRequestActions.js'
import getters from './moduleRequestGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
